
import Vue from 'vue'
import BankCard from '../bank-card/index.vue'
import TabDefault from '~/components/ui/tab/tab-default.vue'
import staticBlockMixin from '~/mixins/staticBlockMixin'

export default Vue.extend({
  name: 'BankCardList',
  components: {
    BankCard,
    TabDefault
  },
  mixins: [staticBlockMixin],
  props: {

  },
  methods: {
    getBlockProperties (fields: { [key: string]: any }) {
      return Object.entries(fields)?.reduce((acc, curr) => {
        if (curr[0].includes('property')) { acc.push(curr[1]) }
        return acc
      }, [] as any[])
    }
  }
})
